var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"grid",class:_vm.classes},_vm._l((_vm.tiles),function(tile,index){return _c('Card',{key:index,attrs:{"tiles":_vm.tiles[index]}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }